import {t} from "@lingui/core/macro";
import React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import Link from "@khanacademy/wonder-blocks-link";
import {PermissionsInfo, useUserAttributes} from "@repo/shared-core";

import type {guideTranscript_aiGuideThread as Thread} from "./__graphql-types__/guideTranscript.ts";
import {getEssaySessionIdFromWritingCoachUrl} from "./get-essay-session-id-from-writing-coach-url.ts";

import externalLinkIcon from "@phosphor-icons/core/bold/arrow-square-out-bold.svg";

export default function MaybeEssayReportLink(props: {
    thread: Thread;
}): React.ReactElement | null {
    const userAttributes = useUserAttributes();
    const isTeacher = !!userAttributes?.isTeacher;

    const interactionUrl = props.thread.interactions[0]?.url ?? "";
    const essaySessionId = getEssaySessionIdFromWritingCoachUrl(interactionUrl);

    if (essaySessionId && (PermissionsInfo.hasAnyPermissions || isTeacher)) {
        return (
            <Link
                target="_blank"
                href={`/writing-coach/inspect/${essaySessionId}`}
                endIcon={<PhosphorIcon icon={externalLinkIcon} />}
            >
                {t`View essay snapshot`}
            </Link>
        );
    }
    return <></>;
}
